import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import {
  initializeAppCheck,
  ReCaptchaEnterpriseProvider,
} from "firebase/app-check";

const firebaseConfig = {
  apiKey: "AIzaSyAumuCpaJsjCGAghQs9F1Qgfz34qc32OKk",
  authDomain: "technpack-78d37.firebaseapp.com",
  projectId: "technpack-78d37",
  storageBucket: "technpack-78d37.firebasestorage.app",
  messagingSenderId: "773370470882",
  appId: "1:773370470882:web:9053ddefcfda9087f599bb",
  measurementId: "G-Z1E3G8MG6M",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

const isDevelopment = import.meta.env.DEV;
const shouldEnableAppCheck = import.meta.env.VITE_ENABLE_APP_CHECK === "true";
const appCheckSiteKey = import.meta.env.VITE_RECAPTCHA_ENTERPRISE_SITE_KEY;

if (isDevelopment) {
  if (typeof self !== "undefined") {
    self.FIREBASE_APPCHECK_DEBUG_TOKEN =
      import.meta.env.VITE_FIREBASE_APPCHECK_DEBUG_TOKEN ||
      "85ea4e9d-84ce-47bd-9102-53b1ee86d651";
  }
  auth.settings.appVerificationDisabledForTesting = true;
} else if (shouldEnableAppCheck && appCheckSiteKey) {
  initializeAppCheck(app, {
    provider: new ReCaptchaEnterpriseProvider(appCheckSiteKey),
    isTokenAutoRefreshEnabled: true,
  });
} else {
  // App Check is optional during domain migration; enable after keys/domains are configured.
  console.info("App Check is disabled. Set VITE_ENABLE_APP_CHECK=true with a valid enterprise site key to enable it.");
}

export { auth };
